export default "__VITE_ASSET__BT6nub4j__"